import { render } from "./app.html?vue&type=template&id=f19a27c6&scoped=true&ts=true"
import script from "./app.ts?vue&type=script&lang=ts"
export * from "./app.ts?vue&type=script&lang=ts"

import "./app.scss?vue&type=style&index=0&id=f19a27c6&lang=scss&scoped=true"

import exportComponent from "/home/antonio/work/zanzar/inventario-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f19a27c6"]])

export default __exports__